import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门推荐</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 6).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <span className="text-[11px] text-foreground-500">{item.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5">
          <div
            className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
          >
            <div className="relative sm:w-[400px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
              <img
                src={cardsData[6].image}
                alt={cardsData[6].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                {cardsData[6].tag}
              </span>
            </div>
            <div className="p-6 flex flex-col justify-center">
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{cardsData[6].title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cardsData[6].desc}</p>
              <span className="text-xs text-foreground-500">{cardsData[6].date}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}